import { render, staticRenderFns } from "./table_product_details.vue?vue&type=template&id=21137818&scoped=true"
import script from "./table_product_details.vue?vue&type=script&lang=js"
export * from "./table_product_details.vue?vue&type=script&lang=js"
import style0 from "./table_product_details.vue?vue&type=style&index=0&id=21137818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21137818",
  null
  
)

export default component.exports